import { useTranslation } from '@mc/i18n'

import { PricingText } from 'components/PricingText'
import { Cta } from 'pages/categories/CategoryPage/components/Hero/Cta'
import { usePageData } from 'pages/categories/CategoryPage/components/PageDataProvider'

export const Hero = () => (
  <div className='mc-my-10 d-flex flex-column align-items-center'>
    <HeroHeading />
    <HeroCta />
  </div>
)

const HeroHeading = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <>
      <h1
        className='mc-text-d1 mc-text--brand mc-text--uppercase d-none d-md-block'
        style={{ fontSize: '72px' }}
      >
        {t('categories.allCats.title')}
      </h1>
      <h1
        className='mc-text-d1 mc-text--brand mc-text--uppercase d-block d-md-none mc-text--center'
        style={{ fontSize: '46px' }}
      >
        {t('categories.allCats.title')}
      </h1>
    </>
  )
}

const HeroCta = () => {
  const { slug } = usePageData()

  return (
    <div className='mc-mt-8 row justify-content-center align-items-start'>
      <div className='col-12 col-md-auto'>
        <Cta slug={slug} />
      </div>
      <PricingText
        translationKey='long'
        className='col-9 col-md-6 mc-text-small mc-opacity--hinted mc-text-md--left mc-text--center'
      />
    </div>
  )
}
